import React from "react";
import { Outlet } from "react-router-dom";
import { FaArrowTrendUp } from "react-icons/fa6";
import { Chart } from "react-google-charts";
import RevenueImpactChart from "../../components/RevenueImpactChart";
import UserCompositionChart from "../../components/UsersComposition";
import { Table } from "../../components/Tables";

const cards = [
  {
    title: "Total Students",
    percentage: "10.0%",
    value: 100,
    detail: "Users",
  },

  {
    title: "Total Courses",
    percentage: "10.0%",
    value: 50,
    detail: "Courses",
  },

  {
    title: "Total Income",
    percentage: "10.0%",
    value: "$500",
    detail: "Classrooms",
  },
  {
    title: "Total Classes",
    percentage: "10.0%",
    value: 10,
    detail: "Users",
  },
];

const userData = [
  {
    name: "Ella Alexandra",
    dateRegistered: "24 May, 2024",
    phoneNumber: "09067890725",
    email: "ellaalexis@gmail.com",
    action: "view",
  },
  {
    name: "John Doe",
    dateRegistered: "23 May, 2024",
    phoneNumber: "09067890726",
    email: "johndoe@gmail.com",
    action: "view",
  },
  {
    name: "Jane Smith",
    dateRegistered: "22 May, 2024",
    phoneNumber: "09067890727",
    email: "janesmith@gmail.com",
    action: "view",
  },
  {
    name: "Chris Johnson",
    dateRegistered: "21 May, 2024",
    phoneNumber: "09067890728",
    email: "chrisjohnson@gmail.com",
    action: "view",
  },
  {
    name: "Patricia Brown",
    dateRegistered: "20 May, 2024",
    phoneNumber: "09067890729",
    email: "patriciabrown@gmail.com",
    action: "view",
  },
];

export default function Dashboard() {
  return (
    <div className="m-4">
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
          {cards.map((card) => (
            <Card key={card.title} card={card} />
          ))}
        </div>

        {/* Graph */}
        <div className="mt-10 flex items-center gap-10">
          <div className="w-[65%]">
            <div className="w-auto h-[350px] bg-white rounded-lg border border-[#D3CBFB] p-2">
              <RevenueImpactChart />
            </div>
          </div>
          <div className="w-[28%]">
            <div className="bg-white rounded-lg border border-[#D3CBFB] p-2  h-[350px]">
              <UserCompositionChart />
            </div>
          </div>
        </div>

        <div className="w-[96%] bg-white rounded-lg border border-[#D3CBFB] overflow-y-scroll h-[373px] mt-6 ">
          <div className="p-3">
            <table className="w-full text-[#013467] mb-6 border-collapse">
              <thead>
                <tr className="text-left">
                  <th className="font-semibold py-2 px-4">Name</th>
                  <th className="font-semibold py-2 px-4">Date Registered</th>
                  <th className="font-semibold py-2 px-4">Phone Number</th>
                  <th className="font-semibold py-2 px-4">Email Address</th>
                  <th className="font-semibold py-2 px-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {userData.map((user, index) => (
                  <Table user={user} key={index} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

function Card({ card }) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-lg w-72">
      <div className="">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-bold text-[#343434] text-16">{card.title}</h3>
          <div className="bg-[#c8f1c3] text-[#0B8A00] p-1 rounded-full font-medium flex items-center gap-2">
            <FaArrowTrendUp size={20} />
            <span className="text-14 font-semibold">{card.percentage}</span>
          </div>
        </div>
        <h1 className="text-[#232323] text-28 font-bold">{card.value}</h1>
        <h5 className="text-13 text-[#949494]">{card.detail}</h5>
      </div>
    </div>
  );
}
